






































import {Component, Prop, Vue} from 'vue-property-decorator';
import {i18nMixin} from '@/modules/neodash/mixins';
import {EconomicGroup} from '@/modules/business-plan/modules/approval/pages/ford-goal-settings/types';
import {SaleType} from '@/modules/business-plan/modules/models/constants/saleType';
import {storeStatus} from '@/modules/business-plan/modules/models/enums/storeStatus';
import TableDialogStore from '@/modules/business-plan/modules/approval/pages/ford-goal-settings/table-dialog-store.component.vue';
import TableMethodologicalInfo from '@/modules/business-plan/modules/approval/pages/ford-goal-settings/table-methodological-info.component.vue';
import IconComponent from '@/modules/business-plan/common/utils/icon.component.vue';

@Component({
  name: 'TitleTableGoalSettingComponent',
  components: {TableDialogStore, IconComponent, TableMethodologicalInfo}
})
export default class TitleTableGoalSettingComponent extends Vue {
  public readonly translate = i18nMixin.methods.i18n;
  public readonly storeStatus = storeStatus;
  public openModal: boolean = false;
  public openModalDealerships: boolean = false;
  public openModalMethodological: boolean = false;

  @Prop({required: true})
  public saleType: SaleType;

  @Prop({required: true})
  public economicGroup: EconomicGroup;

  private get textTitleDialogStore() {
    return `Rede - Grupo Herdeiro (${this.economicGroup.nameGroup})`;
  }

  private toggleModal() {
    this.openModal = !this.openModal;
  }

  private toggleModalDealerships() {
    this.openModalDealerships = !this.openModalDealerships;
  }

  private toggleModalMethodologicalInfo() {
    this.openModalMethodological = !this.openModalMethodological;
  }
}
